import { render, staticRenderFns } from "./DAPrimary900Button.vue?vue&type=template&id=667ffe6f"
import script from "./DAPrimary900Button.vue?vue&type=script&lang=js"
export * from "./DAPrimary900Button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports